<template>
  <div v-loading="showFlag">
    <t-card>
      <div>
        <!-- 納品異常テーブル -->
        <t-table
          ref="deliveryExTable"
          :data="deliveryExTable"
          header-cell-class-name="bg-default"
          :height="detailHeight"
          :cell-class-name="tableCellClassName"
          border
        >
          <!-- UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓ -->
          <!-- <t-table-column
            v-for="(column, index) in columns"
            :key="index"
            :type="column.type"
            :prop="column.prop"
            :label="column.label"
            :min-width="column.width"
            :align="column.align"
            :show-overflow-tooltip="column.overflowTooltip"
          > -->
          <t-table-column
            v-for="(column, index) in columns"
            :key="index"
            :type="column.type"
            :prop="column.prop"
            :label="column.label"
            :min-width="column.width"
            :align="column.align"
            :class-name="`${column.class} input_font_small`"
            :show-overflow-tooltip="column.overflowTooltip"
          >
            <!-- UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑ -->

            <!-- ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓ -->
            <!-- 納期、注番の変更(見積単位⇒製品単位に変更) -->
            <template slot-scope="scope">
              <t-date-picker
                v-if="cusDeliveryDateInputProc(scope.row, column)"
                v-model="scope.row[column.prop]"
                class="dialogDate cell_input_font_small"
                :clearable="false"
                type="date"
                value-format="yyyy/MM/dd"
                format="yyyy/MM/dd"
                :editable="false"
                :show-icon="false"
              >
              </t-date-picker>
              <span v-else>
                {{ scope.row[column.prop] }}
              </span>
            </template>
            <!-- ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑ -->
          </t-table-column>
          <!-- ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓ -->
          <!-- 課題_備考機能の追加 -->
          <!-- UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓ -->
          <!-- 共通備考の調整 -->
          <!-- <t-table-column
            :label="$t('resource.REMARKS_ADD.REMARKS')"
            :class-name="'cell_txt_center input_font_small'"
            :min-width="100"
          >
            <template slot-scope="scope">
              <div class="button-container">
                <t-tooltip placement="bottom" effect="light">
                  <div
                    slot="content"
                    class="tooltip-content"
                    v-html="formatRemarksShowProc(scope.row.aodProdRemarks)"
                  ></div>
                  <t-button
                    :type="getIconTypeProc(scope.row.aodProdRemarks)"
                    icon="el-icon-search"
                    size="small"
                    circle
                  >
                  </t-button>
                </t-tooltip>
              </div>
            </template>
          </t-table-column> -->
          <t-table-column
            :label="$t('resource.REMARKS_ADD.REMARKS')"
            prop="aodProdRemarks"
            :class-name="'cell_txt_center input_font_small'"
            :width="getRemarksColumnWidthProc()"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <div class="bikouDiv">
                <!-- 備考表示 -->
                <span class="bikouText">
                  {{ scope.row.aodProdRemarks }}
                </span>
              </div>
            </template>
          </t-table-column>
          <!-- UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑ -->
          <!-- ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑ -->
        </t-table>
      </div>

      <!-- ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓ -->
      <!-- 納期、注番の変更(見積単位⇒製品単位に変更) -->
      <div :style="{ height: bottomHeight + 'px' }">
        <t-form label-position="right">
          <t-row type="flex" justify="end">
            <div>
              <t-col :span="24">
                <t-button
                  round
                  type="warning"
                  class="dialogButton_confirm_120_40"
                  ref="confirmBtn"
                  :disabled="deliveryExTable.length <= 0"
                  @click="confirmClick"
                >
                  <i class="el-icon-check"></i>
                  {{ $t("resource.sys.sure") }}</t-button
                >
              </t-col>
            </div>
          </t-row>
        </t-form>
      </div>
      <!-- ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑ -->
    </t-card>
  </div>
</template>
<script>
import { getUserInfo } from "@/auth";
import { t } from "@/locales";
import {
  saveProductExInfoByAobQuoteNo,
  searchProductExInfoByAobQuoteNo,
} from "@/services/acceptOrder";
import {
  cmpDetailData,
  formatDateStrToString,
  formatDateToString,
  formatRemarksShow,
  getDialogContentHeight,
  getIconType,
  getRemarksColumnWidth,
} from "@/utils/comFunction";
import { DIALOG_LINE_HEIGHT, STR_EMPTY } from "@/utils/const";
import { Message, Modal } from "@tellus/component";
export default {
  data() {
    return {
      //納品異常テーブル
      deliveryExTable: [],

      //納品異常テーブルの列
      columns: [
        {
          prop: "aodExCreateDate",
          label: t("resource.ACCEPT_ORDER.EX_CREATE_DATE"),
          width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_TWENTY"),
          align: "center",
        },
        {
          prop: "aodExSendNo",
          label: t("resource.ACCEPT_ORDER.EX_SEND_NO"),
          width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_TWENTY"),
          align: "left",
        },
        {
          prop: "aodProdName",
          label: t("resource.COMMON_CONSTANT.PRODUCT_NAME"),
          width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_FIFTY"),
          align: "left",
        },
        {
          prop: "aodProdDrawNo",
          label: t("resource.COMMON_CONSTANT.PICTURE_NO"),
          width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_TWENTY"),
          align: "left",
        },
        // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
        // 納期、注番の変更(見積単位⇒製品単位に変更)
        // 得意先納期
        {
          prop: "aodCusDeliveryDate",
          label: t("resource.ACCEPT_ORDER.CUSTOMER_DELIVERY_DATE"),
          width: t("widgetSize.tableCommon.width170"),
          class: "cell_txt_center",
        },
        // 得意先納期履歴
        {
          prop: "aodCusDeliveryDateHistory",
          label: t("resource.ACCEPT_ORDER.AOD_CUS_DELIVERY_DATE_HISTORY"),
          width: t("widgetSize.tableCommon.width150"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // 注番
        {
          prop: "aodCusOrderNo",
          label: t("resource.ACCEPT_ORDER.CUS_ORDER_NO"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          maxLength: 20,
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑
        {
          prop: "aodExSendQuantity",
          label: t("resource.ACCEPT_ORDER.EX_SEND_QUANTITY"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          align: "right",
        },
        {
          prop: "aodProdExQty",
          label: t("resource.ACCEPT_ORDER.PROD_EX_QTY"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          align: "right",
        },
        {
          prop: "aodCloseState",
          label: t("resource.ACCEPT_ORDER.CLOSE_STATE"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          align: "center",
        },
        // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
        // 課題_備考機能の追加
        // {
        //   prop: "aodRemarks",
        //   label: t("resource.COMMON_CONSTANT.BIKOU"),
        //   width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_FIFTY"),
        //   align: "left",
        // },
        // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
      ],

      //明細情報のheight
      detailHeight: getDialogContentHeight(
        window.innerHeight,
        DIALOG_LINE_HEIGHT * 0,
        DIALOG_LINE_HEIGHT * 1,
        0
      ),
      // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
      // 納期、注番の変更(見積単位⇒製品単位に変更)
      //合計情報のheight
      bottomHeight: DIALOG_LINE_HEIGHT * 1,
      //比較用明細情報
      cmpDetailResult: {},
      //読み込み回数
      numLoads: 1,
      // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑

      data: null,

      showFlag: false,
    };
  },
  props: {
    aobQuoteNo: {
      Type: String,
      default: STR_EMPTY,
    },
    closeStateList: {
      Type: Array,
      default: [],
    },
  },
  mounted() {
    this.Init();
    //テーブルの高さを監視する
    window.addEventListener("resize", this.handleResize);
  },

  methods: {
    // 初期化
    Init() {
      this.showFlag = true;
      //検索納品異常情報
      searchProductExInfoByAobQuoteNo({
        aobQuoteNo: this.aobQuoteNo,
      })
        .then((res) => {
          //納品異常テーブル
          this.deliveryExTable = res;

          //データ処理
          this.dataProcess();
        })
        .catch((err) => {
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(
              t("message.COMMON_MESSAGE.DETAIL_SEARCH_FAILURE")
            );
          }
        })
        .finally(() => {
          this.showFlag = false;
        });
    },

    //テーブルの高さを設定する
    handleResize() {
      this.detailHeight = getDialogContentHeight(
        window.innerHeight,
        DIALOG_LINE_HEIGHT * 0,
        DIALOG_LINE_HEIGHT * 1,
        0
      );
    },

    //データ処理
    dataProcess() {
      this.deliveryExTable.map((item) => {
        //クローズ状態の変換
        item.aodCloseState = this.closeStateList.find(
          (it) => it.value === item.aodCloseState
        )?.label;
        // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
        // 納期、注番の変更(見積単位⇒製品単位に変更)
        //得意先納期
        item.aodCusDeliveryDate = formatDateToString(item.aodCusDeliveryDate);
        // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑

        //異常製品の提出日の変換
        item.aodExCreateDate = formatDateStrToString(item.aodExCreateDate);
      });

      //読み込み回数=1
      if (this.numLoads == 1) {
        //比較用詳細情報
        this.cmpDetailResult = JSON.parse(
          JSON.stringify(this.extract(this.deliveryExTable))
        );

        this.numLoads = this.numLoads + 1;
      }
    },
    // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
    // 納期、注番の変更(見積単位⇒製品単位に変更)
    //納期コントロール
    cusDeliveryDateInputProc(row, column) {
      //納期以外の場合、何もしない
      if (column.prop !== "aodCusDeliveryDate") {
        return;
      }
      return true;
    },
    //セルの配置
    tableCellClassName({ row, column, rowIndex, columnIndex }) {
      row.index = rowIndex;
      column.index = columnIndex;

      if (column.property === "aodCusDeliveryDate") {
        //編集可能の背景色
        return "bg-cell-editable";
      }
    },

    //确定ボタン
    confirmClick() {
      if (typeof this.$refs.confirmBtn !== "undefined") {
        // フォーカス削除
        this.$refs.confirmBtn.$el.blur();
      }

      if (!this.showFlag) {
        this.showFlag = true;
      }

      //保存
      saveProductExInfoByAobQuoteNo({
        acceptOrderDetailInfoList: this.deliveryExTable,
        aobQuoteNo: this.aobQuoteNo,
        user: getUserInfo().UserId,
      })
        .then((res) => {
          this.numLoads = 1;
          Message.showSuccess(t("message.COMMON_MESSAGE.UPDATE_SUCCESS"));
          this.Init();
        })
        .catch((err) => {
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(t("message.COMMON_MESSAGE.UPDATE_FAILURE"));
          }
        })
        .finally(() => {
          this.showFlag = false;
        });
    },

    //テーブルで変更される可能性のある列の取得
    extract(data) {
      return data.map((item, index) => {
        return {
          index: index,
          aodCusDeliveryDate: item.aodCusDeliveryDate,
        };
      });
    },

    //ダイアログを閉じる
    onCancel() {
      if (
        this.deliveryExTable.length > 0 &&
        !cmpDetailData(
          this.cmpDetailResult,
          JSON.parse(JSON.stringify(this.extract(this.deliveryExTable)))
        )
      ) {
        return new Promise((resolve, reject) => {
          Modal.showWarning(
            "",
            t("message.COMMON_MESSAGE.DATA_ALREADY_CHANGED_CLOSE"),
            {
              $type: "prompt",
              confirmButtonText: t("resource.button.sure"),
              cancelButtonText: t("resource.button.cancel"),
              showCancelButton: true,
            }
          )
            .then(() => {
              // 用户点击确认
              resolve(true);
            })
            .catch((error) => {
              // 用户点击取消或关闭对话框
              resolve(false);
            });
        });
      } else {
        return true;
      }
    },
    // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑

    // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
    // 課題_備考機能の追加
    //備考表示用
    formatRemarksShowProc(value) {
      return formatRemarksShow(value);
    },

    getIconTypeProc(value) {
      return getIconType(value);
    },

    // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
    // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓
    // 共通備考の調整（備考列幅の設定）
    getRemarksColumnWidthProc() {
      return getRemarksColumnWidth(this.deliveryExTable);
    },
    // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑
  },
};
</script>

